import dayjs from 'dayjs';
import { Link } from 'react-router-dom';

import { Pill } from 'components/pill/Pill';
import { formatDate, formatDateTime } from '@utils/date';
import type { UserActivityTimelineItem } from 'src/app/audit-log/endpoints/UserActivityStatsEndpoint.types';
import { getActionPillColor, groupTimelineByDate } from './user-activity.utils';

interface UserActivityTimelineProps {
  entries: UserActivityTimelineItem[];
  emptyTitle?: string;
}

export function UserActivityTimeline({ entries, emptyTitle = 'Geen activiteit gevonden' }: UserActivityTimelineProps) {
  if (entries.length === 0) {
    return <div className="text-sm text-fg-secondary py-6 text-center">{emptyTitle}</div>;
  }

  const groups = groupTimelineByDate(entries);

  return (
    <div className="space-y-8">
      {groups.map((group) => (
        <div key={group.date}>
          <div className="sticky top-0 z-10 bg-surface-sunken py-2 mb-4 border-b border-border">
            <div className="text-sm font-medium text-fg-secondary">{formatDate(group.date)}</div>
          </div>

          <div className="relative pl-6">
            <div className="absolute left-[7px] top-2 bottom-2 w-px bg-border" />

            <div className="space-y-4">
              {group.entries.map((entry) => (
                <div key={entry.id} className="relative flex gap-4">
                  <div className="absolute -left-6 top-1.5 h-3 w-3 rounded-full border-2 border-brand bg-surface-sunken" />

                  <div className="min-w-[52px] pt-0.5 text-sm text-fg-secondary tabular-nums">
                    {dayjs(entry.createdAt).format('HH:mm')}
                  </div>

                  <div className="flex-1 min-w-0 pb-1">
                    <div className="flex flex-wrap items-center gap-2 mb-1">
                      <Pill color={getActionPillColor(entry.actionType)} size="sm">
                        {entry.actionType}
                      </Pill>
                      <span className="text-xs text-fg-muted">{formatDateTime(entry.createdAt)}</span>
                    </div>

                    <Link to={`/internal/audit-logs/${entry.id}`} className="link-text text-sm wrap-break-word">
                      {entry.description}
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
